"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as n, jsxs as E, Fragment as W } from "react/jsx-runtime";
import * as a from "react";
import D from "classnames";
import K from "./spinner.js";
import { BaseTouchable as g } from "./touchable.js";
import { useIsInverseVariant as O } from "./theme-variant-context.js";
import { useForm as V } from "./form-context.js";
import { pxToRem as w } from "./utils/css.js";
import { Text as j, Text3 as H, Text2 as Y } from "./text.js";
import $ from "./box.js";
import { getTextFromChildren as P } from "./utils/common.js";
import { useTrackingConfig as F, eventNames as z, eventCategories as M, eventActions as q } from "./utils/analytics.js";
import { useTheme as S } from "./hooks.js";
import { flattenChildren as J } from "./skins/utils.js";
import { inverseButtonVariants as Q, buttonVariants as U, small as p, isLoading as G, textContent as ee, inverseLinkVariants as te, linkVariants as ne, PADDING_X_LINK as T, PADDING_Y_LINK as A, textContentLink as ie, SMALL_SPINNER_SIZE as re, SPINNER_SIZE as ae, ICON_MARGIN_PX as C, CHEVRON_MARGIN_LEFT_LINK as oe, loadingFiller as le, X_SMALL_PADDING_PX as se, X_PADDING_PX as ce, loadingContent as de, SMALL_ICON_SIZE as ue, ICON_SIZE as me } from "./button.css-mistica.js";
import { VIVO_NEW_SKIN as fe } from "./skins/constants.js";
const k = (param)=>{
    let { content: e, defaultIconSize: t, renderText: i } = param;
    const l = J(e), u = l.length, c = [];
    let s = [];
    const f = ()=>{
        c.push(/* @__PURE__ */ n(a.Fragment, {
            children: i(s)
        }, c.length)), s = [];
    };
    return l.forEach((d, m)=>{
        const h = m === 0, o = m === u - 1;
        if (/*#__PURE__*/ a.isValidElement(d)) {
            s.length && f();
            var _d_props_size;
            const v = (_d_props_size = d.props.size) !== null && _d_props_size !== void 0 ? _d_props_size : t;
            c.push(/* @__PURE__ */ n("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    marginLeft: h ? 0 : C,
                    marginRight: o ? 0 : C
                },
                children: /*#__PURE__*/ a.cloneElement(d, {
                    size: w(v)
                })
            }, c.length));
        } else s.push(d), o && f();
    }), c;
}, he = ()=>{
    const { skinName: e } = S();
    return e === fe ? /* @__PURE__ */ n("svg", {
        width: "0.5em",
        height: "0.5em",
        viewBox: "0 0 8 8",
        fill: "none",
        children: /* @__PURE__ */ n("path", {
            d: "M5.11111 3.68886L2.73534 1.30383C2.63671 1.21526 2.51339 1.1909 2.4052 1.20285C2.29952 1.21452 2.19613 1.26162 2.12144 1.33458C2.04957 1.40271 2.00869 1.50793 2.00126 1.60783C1.9934 1.71334 2.02104 1.83978 2.12131 1.93639L4.33333 4.07775L2.11406 6.20689L2.11057 6.21056L2.10821 6.21315L2.10381 6.21806C2.01525 6.31669 1.99089 6.44001 2.00284 6.5482C2.01451 6.65388 2.06161 6.75727 2.13456 6.83196C2.20269 6.90383 2.30792 6.94471 2.40782 6.95215C2.51332 6.96 2.63976 6.93237 2.73638 6.83209L5.11111 4.46664C5.32589 4.25186 5.32589 3.90364 5.11111 3.68886Z",
            fill: "currentColor"
        })
    }) : /* @__PURE__ */ n("svg", {
        width: "0.5em",
        height: "0.5em",
        viewBox: "0 0 8 8",
        children: /* @__PURE__ */ n("path", {
            d: "M6.32595 3.46071L3.03801 0.158595L3.03292 0.153747L3.032 0.152903L3.02931 0.150463L3.02848 0.149738L3.02248 0.144353C2.88533 0.021206 2.71386 -0.0126731 2.56343 0.00394249C2.41648 0.0201739 2.27272 0.0856702 2.16886 0.18711C2.06893 0.281844 2.01209 0.42816 2.00175 0.567065C1.99083 0.71377 2.02925 0.889583 2.16869 1.02392L5.24446 4.00145L2.15859 6.96199L2.15375 6.96708L2.1529 6.968L2.15046 6.97069L2.14974 6.97152L2.14435 6.97752C2.02121 7.11467 1.98733 7.28614 2.00394 7.43657C2.02017 7.58352 2.08567 7.72728 2.18711 7.83114C2.28184 7.93107 2.42816 7.98791 2.56706 7.99825C2.71377 8.00917 2.88958 7.97075 3.02392 7.83132L6.32595 4.5422V4.5422C6.6246 4.24355 6.6246 3.75935 6.32595 3.46071V3.46071Z",
            fill: "currentColor"
        })
    });
}, X = (param)=>{
    let { showSpinner: e, children: t, small: i, loadingText: l, shouldRenderSpinner: u, setShouldRenderSpinner: c, renderText: s, textContentStyle: f, StartIcon: d, EndIcon: m, withChevron: h } = param;
    const o = i ? ue : me, r = w(i ? re : ae);
    return /* @__PURE__ */ E(W, {
        children: [
            /* @__PURE__ */ E("div", {
                "aria-hidden": e ? !0 : void 0,
                className: f,
                children: [
                    d && /* @__PURE__ */ n("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            marginRight: C
                        },
                        children: /* @__PURE__ */ n(d, {
                            size: w(o),
                            color: "currentColor"
                        })
                    }),
                    /* @__PURE__ */ E("div", {
                        style: {
                            display: "flex",
                            alignItems: "baseline"
                        },
                        children: [
                            k({
                                content: t,
                                defaultIconSize: o,
                                renderText: s
                            }),
                            h && /* @__PURE__ */ n("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: oe
                                },
                                children: /* @__PURE__ */ n(he, {})
                            })
                        ]
                    }),
                    m && !h && /* @__PURE__ */ n("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            marginLeft: C
                        },
                        children: /* @__PURE__ */ n(m, {
                            size: w(o),
                            color: "currentColor"
                        })
                    })
                ]
            }),
            /* @__PURE__ */ n("div", {
                className: le,
                "aria-hidden": !0,
                style: l ? {
                    paddingLeft: r,
                    paddingRight: C + 2 * (i ? se : ce)
                } : void 0,
                children: k({
                    content: l,
                    defaultIconSize: o,
                    renderText: s
                })
            }),
            /* @__PURE__ */ E("div", {
                "aria-hidden": e ? void 0 : !0,
                className: de,
                onTransitionEnd: ()=>{
                    e !== u && c(e);
                },
                children: [
                    u ? /* @__PURE__ */ n(K, {
                        rolePresentation: !!l,
                        color: "currentcolor",
                        delay: "0s",
                        size: r
                    }) : /* @__PURE__ */ n("div", {
                        style: {
                            display: "inline-block",
                            width: r,
                            height: r
                        }
                    }),
                    l ? /* @__PURE__ */ n($, {
                        paddingLeft: 8,
                        children: k({
                            content: l,
                            defaultIconSize: o,
                            renderText: s
                        })
                    }) : null
                ]
            })
        ]
    });
}, R = /*#__PURE__*/ a.forwardRef((e, t)=>{
    const { textPresets: i } = S(), { eventFormat: l } = F(), { formStatus: u, formId: c } = V(), s = O(), { loadingText: f } = e, d = !!e.submit, m = u === "sending", [h, o] = a.useState(!1), r = e.showSpinner || m && d || h, [v, L] = a.useState(!!r);
    a.useEffect(()=>{
        r && !v && L(!0);
    }, [
        r,
        v,
        u
    ]);
    var _e_trackingEvent;
    const N = ()=>l === "google-analytics-4" ? {
            name: z.userInteraction,
            component_type: `${e.type}_button`,
            component_copy: P(e.children)
        } : {
            category: M.userInteraction,
            action: `${e.type}_button_tapped`,
            label: P(e.children)
        }, _ = (I)=>e.small ? /* @__PURE__ */ n(j, {
            size: 14,
            lineHeight: 20,
            weight: i.button.weight,
            truncate: 1,
            color: "inherit",
            as: "div",
            children: I
        }) : /* @__PURE__ */ n(H, {
            weight: i.button.weight,
            truncate: 1,
            color: "inherit",
            as: "div",
            children: I
        }), b = {
        ref: t,
        className: D(s ? Q[e.type] : U[e.type], e.className, {
            [p]: e.small,
            [G]: r
        }),
        style: _object_spread({
            cursor: e.fake ? "pointer" : void 0
        }, e.style),
        trackingEvent: (_e_trackingEvent = e.trackingEvent) !== null && _e_trackingEvent !== void 0 ? _e_trackingEvent : e.trackEvent ? N() : void 0,
        dataAttributes: e.dataAttributes,
        "aria-label": e["aria-label"],
        "aria-controls": e["aria-controls"],
        "aria-expanded": e["aria-expanded"],
        "aria-haspopup": e["aria-haspopup"],
        tabIndex: e.tabIndex,
        children: X({
            showSpinner: r,
            shouldRenderSpinner: v,
            setShouldRenderSpinner: L,
            children: e.children,
            loadingText: f,
            small: e.small,
            renderText: _,
            textContentStyle: ee,
            StartIcon: e.StartIcon,
            EndIcon: e.EndIcon
        }),
        disabled: e.disabled || r || m,
        role: e.role
    };
    if (process.env.NODE_ENV !== "production" && (e.to === "" || e.href === "")) throw Error("to or href props are empty strings");
    if (e.fake) return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({
        maybe: !0
    }, b), {
        role: "presentation",
        "aria-hidden": "true"
    }));
    if (e.submit) return /* @__PURE__ */ n(g, _object_spread({
        type: "submit",
        formId: c,
        onPress: ()=>{}
    }, b));
    if (e.onPress) return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({}, b), {
        onPress: (I)=>{
            const y = e.onPress(I);
            y && (o(!0), y.finally(()=>o(!1)));
        }
    }));
    if (e.to || e.to === "") return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({}, b), {
        to: e.to,
        newTab: e.newTab,
        fullPageOnWebView: e.fullPageOnWebView,
        onNavigate: e.onNavigate
    }));
    if (e.href || e.href === "") return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({}, b), {
        href: e.href,
        newTab: e.newTab,
        loadOnTop: e.loadOnTop,
        onNavigate: e.onNavigate
    }));
    if (process.env.NODE_ENV !== "production") throw Error("Bad button props");
    return null;
}), Z = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { type: e } = _param, t = _object_without_properties(_param, [
        "type"
    ]);
    var _t_withChevron;
    const { formStatus: l } = V(), u = O(), { textPresets: c } = S(), { eventFormat: s } = F(), { isDarkMode: f } = S(), { loadingText: d } = t, m = l === "sending", [h, o] = a.useState(!1), r = t.showSpinner || h, v = (_t_withChevron = t.withChevron) !== null && _t_withChevron !== void 0 ? _t_withChevron : !!t.href || !!t.to, [L, N] = a.useState(!!r);
    a.useEffect(()=>{
        r && !L && N(!0);
    }, [
        r,
        L,
        l
    ]);
    var _t_trackingEvent;
    const _ = ()=>s === "google-analytics-4" ? {
            name: z.userInteraction,
            component_type: e === "danger" ? "danger_link" : "link",
            component_copy: P(t.children)
        } : {
            category: M.userInteraction,
            action: q.linkTapped,
            label: P(t.children)
        }, b = (x)=>/* @__PURE__ */ n(Y, {
            weight: c.button.weight,
            truncate: 1,
            color: "inherit",
            children: x
        }), I = e === "danger" && f && u ? "dangerDark" : e, y = {
        className: D(u ? te[I] : ne[I], {
            [G]: r
        }),
        /**
     * Setting bleed classes with style to override the margin:0 set by the Touchable component.
     * If we set it using className, it may not work depending on the order in which the styles are applied.
     */ style: _object_spread({}, t.bleedLeft ? {
            marginLeft: -T
        } : void 0, t.bleedRight ? {
            marginRight: -T
        } : void 0, t.bleedY ? {
            marginTop: -A,
            marginBottom: -A
        } : void 0),
        trackingEvent: (_t_trackingEvent = t.trackingEvent) !== null && _t_trackingEvent !== void 0 ? _t_trackingEvent : t.trackEvent ? _() : void 0,
        dataAttributes: t.dataAttributes,
        "aria-label": t["aria-label"],
        "aria-controls": t["aria-controls"],
        "aria-expanded": t["aria-expanded"],
        "aria-haspopup": t["aria-haspopup"],
        children: X({
            showSpinner: r,
            shouldRenderSpinner: L,
            setShouldRenderSpinner: N,
            children: t.children,
            loadingText: d,
            small: !0,
            renderText: b,
            textContentStyle: ie,
            StartIcon: t.StartIcon,
            EndIcon: t.EndIcon,
            withChevron: v
        }),
        disabled: t.disabled || r || m,
        role: t.role
    };
    if (process.env.NODE_ENV !== "production" && (t.to === "" || t.href === "")) throw Error("to or href props are empty strings");
    if (t.onPress) return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({
        ref: i
    }, y), {
        onPress: (x)=>{
            const B = t.onPress(x);
            B && (o(!0), B.finally(()=>o(!1)));
        }
    }));
    if (t.to || t.to === "") return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({
        ref: i
    }, y), {
        to: t.to,
        newTab: t.newTab,
        fullPageOnWebView: t.fullPageOnWebView,
        onNavigate: t.onNavigate
    }));
    if (t.href || t.href === "") return /* @__PURE__ */ n(g, _object_spread_props(_object_spread({
        ref: i
    }, y), {
        href: t.href,
        newTab: t.newTab,
        onNavigate: t.onNavigate
    }));
    if (process.env.NODE_ENV !== "production") throw Error("Bad button props");
    return null;
}), Re = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { dataAttributes: e } = _param, t = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ n(Z, _object_spread_props(_object_spread({
        dataAttributes: _object_spread({
            "component-name": "ButtonLink"
        }, e)
    }, t), {
        ref: i,
        type: "default"
    }));
}), Be = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { dataAttributes: e } = _param, t = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ n(Z, _object_spread_props(_object_spread({
        dataAttributes: _object_spread({
            "component-name": "ButtonLinkDanger"
        }, e)
    }, t), {
        withChevron: !1,
        ref: i,
        type: "danger"
    }));
}), Te = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { dataAttributes: e } = _param, t = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ n(R, _object_spread_props(_object_spread({
        dataAttributes: _object_spread({
            "component-name": "ButtonPrimary"
        }, e)
    }, t), {
        ref: i,
        type: "primary"
    }));
}), Ae = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { dataAttributes: e } = _param, t = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ n(R, _object_spread_props(_object_spread({
        dataAttributes: _object_spread({
            "component-name": "ButtonSecondary"
        }, e)
    }, t), {
        ref: i,
        type: "secondary"
    }));
}), De = /*#__PURE__*/ a.forwardRef((_param, i)=>{
    var { dataAttributes: e } = _param, t = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ n(R, _object_spread_props(_object_spread({
        dataAttributes: _object_spread({
            "component-name": "ButtonDanger"
        }, e)
    }, t), {
        ref: i,
        type: "danger"
    }));
});
export { De as ButtonDanger, Re as ButtonLink, Be as ButtonLinkDanger, Te as ButtonPrimary, Ae as ButtonSecondary };
